import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var StarHalf = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 32,
    d: "M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 48v316L118 464l54-160-140-96h172l52-160z"
  }));
});
StarHalf.displayName = 'StarHalf';
export var StarHalfDimensions = {
  height: 512,
  width: 512
};